<template>
  <div class="TiptapEditorBox my-2">
    <div class="font-weight-bold" v-if="!hideLabel">
      {{ label }}
    </div>
    <tiptap-vuetify
      v-model="content"
      :extensions="extensions"
      :native-extensions="nativeExtensions"
      ref="tiptap-editor"
    >
      <div class="btnYoutube"
        slot="toolbar-after"
        v-if="hasMedia"
      >
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn
              class="tiptap-vuetify-editor__action-render-btn"
              small
              icon
              v-on="on"
              @click="youtubeDialogShow = true"
            >
              <v-icon
                small
                class="tiptap-vuetify-editor__btn-icon"
                style="font-size: 14px"
              >
                fab fa-youtube
              </v-icon>
            </v-btn>
          </template>
          <template><translate>Youtube</translate></template>
        </v-tooltip>
      </div>
    </tiptap-vuetify>
    <v-dialog :value="youtubeDialogShow" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline" v-translate> Add youtube video </span>

          <v-spacer />

          <v-btn icon @click="youtubeDialogShow = false">
            <v-icon>fas fa-xmark</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="youtubeSrc"
            :label="$gettext('Enter URL here')"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="youtubeDialogShow = false"> Close </v-btn>
          <v-btn text @click="applyYoutube()" v-translate> Apply </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  TiptapVuetify,
  Heading,
  Bold,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Image,
} from "tiptap-vuetify";
import TiptapImageUpload from "@/components/Tiptap/TiptapImageUpload";
import TiptapImageUrl from "@/components/Tiptap/TiptapImageUrl";
import TiptapYoutube from "@/components/Tiptap/TiptapYoutube.js";
export default {
  name: "TiptapEditor",
  components: {
    TiptapVuetify,
  },
  props: {
    value: { type: String, default: "" },
    label: { type: String, default: "" },
    name: { type: String, default: "" },
    hasMedia: { type: Boolean, default: true },
    hideLabel: { type: Boolean, default: false },
    tagOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      youtubeDialogShow: false,
      youtubeSrc: "",
      extensions: [
        Link,
        Bold,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [3],
            },
          },
        ],
        [
          Image,
          {
            renderIn: this.hasMedia ? "toolbar" : "bubbleMenu",
            options: {
              imageSources: [
                { component: TiptapImageUrl, name: "URL" },
                { component: TiptapImageUpload, name: "Upload" },
              ],
              imageSourcesOverride: true,
            },
          },
        ],
      ],
      nativeExtensions: this.hasMedia ? [new TiptapYoutube()] : [],
      content: "",
      faDummy: [
        'fas fa-link',
        'fas fa-bold',
        'fas fa-list-ul',
        'fas fa-list-ol',
        'fas fa-image'
      ]
    };
  },
  methods: {
    reset() {
      this.content = "";
    },
    applyYoutube() {
      const src = this.formatYoutube(this.youtubeSrc);
      if(!src) return
      this.youtubeCommand({ src });
      this.youtubeDialogShow = false;
    },
    formatYoutube(url) {
      const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      const match = url.match(regExp);
      let id = null;
      if (match && match[2].length == 11) {
        id = match[2];
      }
      if(!id) return null
      return 'https://youtube.com/embed/' + id
    }
  },
  computed: {
    youtubeCommand() {
      return this.$refs["tiptap-editor"].nativeExtensions[0].editor.commands
        .youtube;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if(val === '<p>null</p>' || val === 'null') {
          this.content = ''
        } else {
          this.content = val;
        }
      },
    },
    content: {
      handler(val) {
        const fieldName = this.name;
        this.$emit("setInputEditor", { fieldName, val });
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style lang="scss">
.form-group-custom {
  .tiptap-vuetify-editor {
    border: 1px solid #e0e0ee;
    .tiptap-vuetify-editor__toolbar {
      .v-toolbar__content {
        .v-btn {
          .v-icon {
            font-size: 14px;
          }
        }
      }
    }
  }
}
.btnYoutube {position: absolute; left: 240px; top: 5px;}
@media screen and (max-width: 425px) {
  .tiptap-vuetify-editor > div { position: relative;
    .btnYoutube { left: 183px}
  }
  .tiptap-vuetify-editor__action-render-btn {margin: 2px 1px !important;}
}
@media screen and (max-width: 361px) {
  .tiptap-vuetify-editor > div {
    .btnYoutube { left: auto; right:0;}
  }
  .tiptap-vuetify-editor__action-render-btn {margin: 2px 0px !important;}
}
@media screen and (max-width: 320px) {
  .tiptap-vuetify-editor > div {
    .btnYoutube { left: auto; right:0;}
  }
  .tiptap-vuetify-editor__action-render-btn {margin: 2px 1px !important;}
}
</style>
